import "./Home.css";
import { Redirect } from "react-router-dom";

function Home() {
  return <Redirect to="/wheels"></Redirect>;
}

export default Home;
